const Apis = {
   'localhost': 'audiapi.smartintel.io',
   'smartintel.io': 'smartapi.smartintel.io',
   'mobica.smartintel.io': 'mobicaapi.smartintel.io',
   'apple.smartintel.io': 'appleapi.smartintel.io',
   'ishop.smartintel.io': 'ishopapi.smartintel.io',
   'penguin.smartintel.io': 'penguinapi.smartintel.io',
   'audi.smartintel.io': 'audiapi.smartintel.io',
   'app.smartintel.io': 'smartapi.smartintel.io',
   'test.smartintel.io': 'testapi.smartintel.io',
   'temp.smartintel.io': 'tempapi.smartintel.io'
}

module.exports = Apis


// WEBPACK FOOTER //
// ./src/constants/apis.js